// extracted by mini-css-extract-plugin
export default {"uploadWrapper":"DocumentUpload_uploadWrapper__9OFoO","dim":"DocumentUpload_dim__bNf+2"};